import {KEY_CARD_ORDER_BY, KEY_CARD_SORT_TYPE,
    KEY_HIGHLIGHT_ORDER_BY, KEY_HIGHLIGHT_SORT_TYPE, KEY_SHOW_HIDIN_CARDS, PAGE_SIZE} from "@/Const";
import {getVideoImageThumb, isAudio, isVideo, removeHtmlTags} from "@/utils";
import {getCardById, getCardDoc, updateCard} from "@model/card";

let mHighlight:any;

export function initHighlight(db){
    mHighlight = db.table('highlight')
}

export async function dbHighlightCount(){
    return new Promise(async (resolve) => {
        const arrayDatas = await mHighlight.toArray();
        resolve(arrayDatas.length);
    })
}

/**
 * 更新高亮的数据....
 * @param highlight
 */
export async function updateHighlight(highlight:any){
    const library = await getCardById(highlight.id);

    if (!highlight.createTime){
        highlight.createTime = Date.now();
    }

    //如果highlight没有name,但是library中有，使用library中的..
    if (!highlight.name && library?.name){
        highlight.name = library?.name;
    }
    highlight.updateTime = Date.now();
    //取缩略图
    if (!highlight.thumbImage){
        if (highlight?.fileName){
            const card:any = await getCardById(highlight.libraryId);
            if (card){
                highlight.thumbImage = card.thumbImage;
            }else{
                highlight.thumbImage = await getVideoImageThumb("localfile://"+highlight.fileName);
            }
        }
        if (library?.thumbImage){
            highlight.thumbImage = library.thumbImage;
        }
    }

    //更新library中的名称

    if (library){
        library.name = highlight.name;
        library.thumbImage = highlight.thumbImage;
        if (!highlight.data || highlight.data.length == 0){
            if (!isVideo(highlight.fileName) && !isAudio(highlight.fileName)){
                library.isDeleted = highlight.isDeleted;//这里也要存，不然不好判断....
            }
        }else{
            library.isDeleted = highlight.isDeleted;//----
        }

        updateCard(library);
    }

    return mHighlight.put(highlight);
}

/**
 * 获取高亮
 * @param id
 */
export function dbGetHighlight(id:string){
    if (!id)return null;
    return mHighlight.get(id);
}

/**
 * 根据库ID获取高亮
 * @param libraryId
 */
export async function dbGetHighlightByLibraryId(libraryId:string){
    if (!libraryId)return null;
    const array = await mHighlight.filter(p=>p.libraryId == libraryId || p.id == libraryId).toArray();
    if (array.length > 0)return array[0];
    return null;
}

/**
 * 删除高亮
 * @param id
 */
export function dbDeleteHighlight(id:string){
    mHighlight.delete(id);
}

export async function dbGetYoutubeHightlightCount(){
    const array = await mHighlight.filter(p=>p.type == 'youtube' && p.data?.length > 0).toArray();
    return array.length;
}

/**
 * 高亮列表....
 * @param szSearchKey
 * @param arrayTypes
 */
export async function highlightList(szSearchKey:any,arrayTypes:any){
    return new Promise(async (resolve, reject) => {

        // let szSortType = localStorage.getItem(KEY_HIGHLIGHT_SORT_TYPE);
        // let szOrderBy = localStorage.getItem(KEY_HIGHLIGHT_ORDER_BY);
        //
        // if(!szSortType){
        //     szSortType = "sort by updateDate";
        // }
        // if(!szOrderBy){
        //     szOrderBy = "date desc"
        // }
        //
        // let arrayDatas:any;
        //
        // if("sort by name" === szSortType){
        //     if("a-z" === szOrderBy){
        //         arrayDatas = mHighlight.orderBy('name').filter(p=>arrayTypes.includes(p.type));
        //     }else if("z-a" == szOrderBy){
        //         arrayDatas = mHighlight.orderBy('name').reverse().filter(p=>arrayTypes.includes(p.type));
        //     }
        // }else if("sort by createDate" == szSortType){
        //     if("date asc" == szOrderBy){
        //         arrayDatas = mHighlight.orderBy('createTime').filter(p=>arrayTypes.includes(p.type));
        //     }else if("date desc" == szOrderBy){
        //         arrayDatas = mHighlight.orderBy('createTime').reverse().filter(p=>arrayTypes.includes(p.type));
        //     }
        // } else if("sort by updateDate" == szSortType){
        //     if("date asc" == szOrderBy){
        //         arrayDatas = mHighlight.orderBy('updateTime').filter(p=>arrayTypes.includes(p.type));
        //     }else if("date desc" == szOrderBy){
        //         arrayDatas = mHighlight.orderBy('updateTime').reverse().filter(p=>arrayTypes.includes(p.type));
        //     }
        // }

        let arrayResult:any = await mHighlight.filter(p=>arrayTypes.includes(p.type) && p.data?.length > 0 && p.isDeleted != 1).toArray();

        if (szSearchKey){
            szSearchKey = szSearchKey.toLowerCase();
            var arrayNewResult = [];
            for (let i=0;i<arrayResult.length;i++){
                const card = arrayResult[i];
                if (card.name && card.name.toLowerCase().indexOf(szSearchKey) != -1){
                    arrayNewResult.push(card);
                }else{
                    for (let j=0;j<card.data.length;j++){
                        const note = card.data[j];
                        if (note.title && note.title.toLowerCase().indexOf(szSearchKey) != -1){
                            arrayNewResult.push(card);
                            break;
                        } else if (note.content && note.content.toLowerCase().indexOf(szSearchKey) != -1){
                            arrayNewResult.push(card);
                            break;
                        }
                    }
                }
            }
            arrayResult = arrayNewResult;
        }
        resolve(arrayResult);
    })
}